import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { array, number, object, ObjectSchema, string } from 'yup';
import { addressSchema, contactSchema, IOrganisationForm } from '../../shared';

export function useOrganisationSchema(): ObjectSchema<IOrganisationForm> {
    const { t } = useTranslation();

    return useMemo(
        () =>
            object().shape({
                id: string().optional(),
                name: string().required(),
                type: string().required(),
                address: addressSchema().optional(),
                contacts: array().of(contactSchema()).required(),
                supportTypes: array().of(string().required()).required(),
                defaultSupportTypeId: string().when('supportTypes', {
                    is: (supportTypes: string[]) => supportTypes?.length > 1,
                    then: (schema) => schema.required(),
                }),
                defaultSupportPeriod: number().typeError(t('invalidNumber')).required(),
                preferredPostalCodes: array().of(string().required()).nullable().optional(),
            }),
        [t],
    );
}
